import React from 'react';
import { Cushion, MaxWidth, Typography } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const NoSeasonsPlaceholder = () => (
  <Cushion horizontal="large" vertical="xxxlarge">
    <Typography preset="body--large" color="dustygrey" align="center" component="div">
      <MaxWidth component="div" maxWidth={280} center>
        <Trans i18nKey="teams:statistics_no_seasons_placeholder">
          Looks like this team doesn’t have any stats to show yet.
        </Trans>
      </MaxWidth>
    </Typography>
  </Cushion>
);

export default NoSeasonsPlaceholder;
